'use client';
import { PageTitle } from '@/components/page-title';
import SectionTitle from '@/components/section-title/section-title';
import { CourseViewModel } from '@hidayahlab/academy-suite-corelib';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/accordion';
import { nanoid } from 'nanoid';

type CourseDetailsProps = {
  faqs: CourseViewModel['faqs'];
};

export default function CourseDetailsFaq({ faqs }: CourseDetailsProps) {
  if (!faqs) return null;

  const enhancedFaqs = faqs.map(faq => ({ id: nanoid(), ...faq }));

  return (
    <div id="faq" className="p-2 scroll-m-13 md:p-4">
      <div className="grid gap-6 p-4 bg-gray-50 rounded-sm">
        <SectionTitle size="md">
          <PageTitle content="course-details.faq" />
        </SectionTitle>
        {enhancedFaqs.map((faq, index) => {
          return (
            <Accordion
              key={faq.id}
              type="single"
              collapsible
              defaultValue={index === 0 ? `item-${faq.id}` : undefined}
            >
              <AccordionItem
                className="overflow-hidden rounded-sm"
                value={`item-${faq.id}`}
              >
                <div className="p-4 bg-white">
                  <AccordionTrigger className="text-start">
                    <h2 className="w-[70%] md:w-full mt-1 text-base md:text-lg font-medium text-title">
                      {faq.question}
                    </h2>
                  </AccordionTrigger>
                </div>
                <AccordionContent className="px-4 bg-white">
                  <p className="text-sm text-gray-700 md:text-base">
                    {faq.answer}
                  </p>
                </AccordionContent>
              </AccordionItem>
            </Accordion>
          );
        })}
      </div>
    </div>
  );
}
